// Lightweight visitor tracking for public pages.
// Sends a fire-and-forget POST to /api/analytics/track on route change.
// A stable session_id is kept in localStorage so reloads count as same visitor.

import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const SESSION_KEY = 'plancity_visitor_session';

// Paths that are admin/provider/auth — must NOT be tracked
// (we only track public pages per requirements).
const PRIVATE_PREFIXES = [
  '/admin',
  '/provider',
  '/enganche',
  '/login',
  '/register',
  '/para-proveedores',
];

function getOrCreateSessionId() {
  try {
    let sid = localStorage.getItem(SESSION_KEY);
    if (!sid) {
      sid = (crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`);
      localStorage.setItem(SESSION_KEY, sid);
    }
    return sid;
  } catch {
    // localStorage blocked — fall back to per-pageload id
    return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }
}

export function isTrackablePath(path) {
  if (!path) return false;
  return !PRIVATE_PREFIXES.some((p) => path === p || path.startsWith(`${p}/`));
}

export async function trackVisit(path) {
  if (!isTrackablePath(path)) return;
  if (!API_URL) return;
  try {
    await axios.post(`${API_URL}/api/analytics/track`, {
      session_id: getOrCreateSessionId(),
      path,
      referrer: document.referrer || null,
    });
  } catch {
    // Tracking failures must never break the UI.
  }
}
